import { useCurrentTenant } from "contexts/currentTenant";
import { getTenantVersionIsHead } from "reducers/tenant";

export default () => {
  const tenant = useCurrentTenant();
  return tenant ? !getTenantVersionIsHead(tenant) : false;
};
